import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//import utils
import { numberWithCommas } from "../../../utils/utility";

//import general components
import { BaseButton } from "../base-button/base-button";

export default function ActionButton({ text, price, handleRemove }) {
    const { t } = useTranslation();
    return (
        <Grid container item xs={12} md={2} justifyContent="center" alignItems="center">
            <Grid container item xs={6} md={12} justifyContent="center">
                {numberWithCommas(price)} {t("currency")}
            </Grid>
            <Grid container item xs={6} md={12}>
                <BaseButton text={text} color="orange" size="small" radius="radius-10" handleClick={handleRemove} />
            </Grid>
        </Grid>
    );
}
